import { render, staticRenderFns } from "./ThePortfolio.vue?vue&type=template&id=0977bad6&scoped=true"
import script from "./ThePortfolio.vue?vue&type=script&lang=js"
export * from "./ThePortfolio.vue?vue&type=script&lang=js"
import style0 from "./ThePortfolio.vue?vue&type=style&index=0&id=0977bad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977bad6",
  null
  
)

export default component.exports